/**
 * Done. CPD — Landing About / USP Section (Stitch v2 / screen 2)
 * "More Than Just Content" — two teal-border cards positioning Done. CPD
 * as an Automated Compliance Writer, not another video library.
 */

interface USPItem {
  icon: string;
  title: string;
  desc: string;
  bullets: { icon: string; bold: string; rest: string }[];
}

const ITEMS: USPItem[] = [
  {
    icon: 'check_circle',
    title: 'Your Compliance, Sorted',
    desc: 'We handle the annual plan, the outcome descriptions, and the reflections. You review, tweak if you want, and upload to your Board portal. That’s it.',
    bullets: [
      { icon: 'smart_toy',     bold: 'Automated Compliance Writer:', rest: ' we document for you.' },
      { icon: 'auto_awesome',  bold: 'Outcome-Based Learning:',      rest: ' focus on clinic impact.' },
    ],
  },
  {
    icon: 'psychology',
    title: 'Learning That Fits Your Practice',
    desc: 'Every module is matched to how you actually practise — your patient base, your interests, your preferred format. Video, podcast, study guide, quiz. One hour a month.',
    bullets: [
      { icon: 'verified', bold: 'Audit-Ready:', rest: ' perfect certificates, every time.' },
      { icon: 'schedule', bold: 'Efficient:',   rest: ' designed for the busy professional.' },
    ],
  },
];

export function About(): React.ReactElement {
  return (
    <section
      id="section-about"
      className="bg-[var(--stitch-surface-container-lowest)] py-20 md:py-24 border-y border-[var(--stitch-outline-variant)]/40"
    >
      <div
        className="mx-auto px-4 md:px-10"
        style={{ maxWidth: 'var(--stitch-container-max)' }}
      >
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <h2 className="stitch-font-headline text-[28px] md:text-[32px] text-[var(--stitch-primary)] mb-4 uppercase tracking-tight">
            More Than Just Content
          </h2>
          <p className="stitch-font-body text-[16px] text-[var(--stitch-on-surface-variant)]">
            Traditional platforms drown you in video hours. Done. CPD is a purpose-built{' '}
            <span className="text-[var(--stitch-primary)] font-bold">Automated Compliance Writer</span>
            {' '}that translates your learning into audit-ready documentation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-stretch">
          {ITEMS.map(item => (
            <div
              key={item.title}
              className="p-8 rounded-xl stitch-teal-border-card bg-white stitch-ghost-shadow"
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="material-symbols-outlined text-[var(--stitch-primary)]">{item.icon}</span>
                <h3 className="stitch-font-headline text-[18px] uppercase text-[var(--stitch-primary)] tracking-wide">
                  {item.title}
                </h3>
              </div>
              <p className="stitch-font-body text-[15px] text-[var(--stitch-on-surface-variant)] mb-6 leading-relaxed">
                {item.desc}
              </p>
              <ul className="space-y-4">
                {item.bullets.map(b => (
                  <li key={b.bold} className="flex items-start gap-3 stitch-font-body text-[14px] text-[var(--stitch-on-surface-variant)]">
                    <span className="material-symbols-outlined text-[var(--stitch-primary)] shrink-0">{b.icon}</span>
                    <span><strong className="text-[var(--stitch-on-surface)]">{b.bold}</strong>{b.rest}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
